/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import { Link } from '../../../routes';

const KycBox = styled(FlexBox).attrs({ className: 'kycBox' })`
  width: auto;
  margin-left: 10px;
  margin-top:2px;
  > a,
  a:visited {
    font-size: ${({ theme }) => theme.fontSizeSm};
    color: ${({ theme }) => theme.highlight};
    transition: all 0.3s ease-in-out;
    border: 1px solid ${({ theme }) => theme.highlight};
    height: 24px;
    line-height: 23px;
    padding: 0 10px;
    border-radius: 2px;
  }
`;

const Tag = styled.a`
  display: inline-block;
  vertical-align: middle;
  height: 18px;
  line-height: 17px;
  padding: 0 6px;
  border-radius: 2px;
  background-color: ${({ type }) => (type === 1 ? 'rgba(240,185,11,0.3)' : 'rgba(74,144,226,0.3)')};
  font-size: ${({ theme }) => theme.fontSizeSm};
  color: ${({ type }) => type === 1 ? '#F0B90B' : '#4A90E2'};
  border: none!important;
`;

const PendingTag = styled.span`
  display: inline-block;
  vertical-align: middle;
  height: 18px;
  line-height: 17px;
  padding: 0 6px;
  border-radius: 2px;
  background-color: rgba(255,255,255,0.1);
  font-size: ${({ theme }) => theme.fontSizeSm};
  color: rgba(255,255,255,0.5);;
  border: none!important;
`;

type UserKYCInfo = {
  kycStatus: number,
  type: string,
  kycSubStatus: string,
  transId: number | string,
  forbidCountryPassed: boolean,
}

type Props = {
  i18n: Object,
  userKYCInfo: UserKYCInfo,
  authenticationType: number,
  locale: string,
};

const KYC = ({
  i18n, userKYCInfo: {
    kycStatus, type, kycSubStatus, transId, forbidCountryPassed,
  }, authenticationType, locale,
}: Props) => (
  <KycBox>
    {((kycStatus === -1 || kycStatus === 2) && !forbidCountryPassed) && (
      <Link route={`/${locale}/usercenter/settings/select-identity-verification-type`}>{`${getLabel('exchange-nav-verify', i18n)} »`}</Link>
    )}
    {(kycStatus === 2 && forbidCountryPassed) && (
      <Link route={`/${locale}/usercenter/kyc/reject`}>{`${getLabel('exchange-nav-verify', i18n)} »`}</Link>
    )}
    {(kycStatus === 0 && kycSubStatus === 'JUMIO') && (
      <Link route={`/${locale}/usercenter/settings/identity-verification/${type === 'user' ? 'personal' : 'corporate'}/1`}>
        {`${getLabel('exchange-nav-verify', i18n)} »`}
      </Link>
    )}
    {(kycStatus === 0 && kycSubStatus === 'FACE_PENDING') && (
      <Link route={`/${locale}/usercenter/settings/kyc/facial-verification?type=${type}&id=${transId}`}>
        {`${getLabel('exchange-nav-verify', i18n)} »`}
      </Link>
    )}
    {(kycStatus === 0 && kycSubStatus === 'AUDITING') && (
      <PendingTag>{getLabel('exchange-kyc-pendingVerification', i18n)}</PendingTag>
    )}
    {kycStatus === 1 && authenticationType === 1 && (
    <Link route={`/${locale}/usercenter/settings/profile`}>
      <Tag type={authenticationType}>{getLabel('exchange-kyc-personal', i18n)}</Tag>
    </Link>
    )}
    {kycStatus === 1 && authenticationType === 2 && (
    <Link route={`/${locale}/usercenter/settings/profile`}>
      <Tag type={authenticationType}>{getLabel('exchange-kyc-enterprise', i18n)}</Tag>
    </Link>
    )}
  </KycBox>
);

KYC.defaultProps = {
  i18n: {},
  authenticationType: '1',
};

export default KYC;
